import { render } from "./TeamInvites.vue?vue&type=template&id=15054be6"
import script from "./TeamInvites.vue?vue&type=script&lang=js"
export * from "./TeamInvites.vue?vue&type=script&lang=js"
script.render = render

export default script